import React from 'react';
import { ReactNode, useEffect } from 'react';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { matchPath } from 'react-router-dom';
import {
  CROP_COUNTRY_MAPS,
  CROP_FIELD_ANALYSES_VIEW,
  CROP_FIELD_CREATE,
  CROP_FIELD_EDIT,
  CROP_FIELD_IMPORT,
  CROP_FIELD_SPLIT,
  CROP_FIELD_VIEW,
  CROP_FIELDS_AND_WORKS_INDEX,
  CROP_FIELDS_MERGE,
  CROP_WORK_CREATE,
  CROP_WORK_EDIT,
  CROP_WORK_VIEW,
} from '../../../router/routes';
import { setFieldsFilter } from '../../../store/global-slice';

const CROP_FIELDS_FILTER_ROUTES = [
  CROP_COUNTRY_MAPS,
  CROP_FIELDS_AND_WORKS_INDEX,
  CROP_FIELD_VIEW,
  CROP_FIELD_EDIT,
  CROP_FIELD_CREATE,
  CROP_FIELD_IMPORT,
  CROP_FIELDS_MERGE,
  CROP_FIELD_SPLIT,
  CROP_FIELD_ANALYSES_VIEW,
  CROP_WORK_CREATE,
  CROP_WORK_VIEW,
  CROP_WORK_EDIT,
];
export default function CropFieldsFilterContainer({
  children,
}: {
  children: ReactNode;
}) {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    const unlisten = history.listen((location) => {
      const isRouteMatched = CROP_FIELDS_FILTER_ROUTES.some((routePattern) =>
        matchPath(location.pathname, { path: routePattern, exact: true })
      );

      if (!isRouteMatched) {
        dispatch(setFieldsFilter(null));
      }
    });

    return () => {
      unlisten();
    };
  }, [dispatch, history]);

  return <>{children}</>;
}
